import React from "react";
import styled from "styled-components";
import AppMobile from "../assets/AppMobile.svg";
import AppStore from "../assets/app-store.svg";
import GooglePlay from "../assets/google-play.svg";

const AppDownload = () => {
  return (
    <Wrapper style={{ background: "#e5edfc", marginTop: "9%" }}>
      <div className="section-center text-center app_downloads">
        <div className="download_app_wrapper">
          <div className="downbload_image">
            <img
              className="phoneImg"
              src={AppMobile}
              alt="Download the mobile app"
            />
          </div>

          <div className="download_text">
            <h1 className="download_heading_text">
              Download our <br /> Mobile App
            </h1>

            <span className="download_text_description sub_text">
              Available on both Android and iOS
            </span>

            <div className="download_image">
              <img src={AppStore} alt="Apple Store" />
              <img src={GooglePlay} alt="Apple Store" />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .download_app_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 70px;
  }

  .downbload_image {
    width: 470px;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 480px;
  }

  .downbload_image .phoneImg {
    width: 100%;
    position: absolute;
    height: 100%;
    top: 0;
    left: -125px;
    /* padding: 50px 0 0; */
    /* -webkit-transform: translate(-102px, 0px); */
    /* -ms-transform: translate(-102px, 0px); */
    /* transform: translate(-127px, 0px); */
  }
  .fLTxcA .download_text {
    display: flex;
    flex-direction: column;
    align-items: end;
    span {
      display: block;
    }
  }
  .download_text_description {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 0px;
    display: flex;
    align-items: center;
    color: #545777;
    padding: 46px 0px;
  }
  .download_image img {
    padding-right: 10px;
  }
  .download_heading_text {
    color: var(--heading-font-color);
    font-family: "Gilroy-Heavy";
    font-size: 36px;
    font-weight: 600px;
    line-height: 46px;
    text-align: left;
  }
  @media screen and (max-width: 768px) {
    .download_app_wrapper {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -webkit-align-items: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      justify-content: center;
      padding: 50px 0;
      width: 100%;
    }
    .download_text {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .download_heading_text {
      color: var(--heading-font-color);
      font-family: "Gilroy-Heavy";
      font-size: 36px;
      font-weight: 600px;
      line-height: 46px;
      text-align: center !important;
    }
    .downbload_image {
      display: none;
    }
  }
`;

export default AppDownload;
